export const deleteRows = <T>(rowsData: T[], entriesToDelete: string[], deleteBy: keyof T & string) => {
    return rowsData.reduce((acc, current) => {
        const key = typeof current[deleteBy] === 'string' ? String(current[deleteBy]) : '';
        if (key && entriesToDelete.includes(key)) {
            return acc;
        }
        return [...acc, current];
    }, new Array<T>());
};
